module.exports = __webpack_public_path__ + "static/img/footer_logo_pc.286e3b3f.svg";